export default "__VITE_ASSET__B3soiFUa__"